module.exports = __webpack_public_path__ + "static/media/high_five_click_here@2x.6bbf1ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/high_five_click_here@2x.png
// module id = 469
// module chunks = 0